/** Shown wherever a version-details value has never been set. */
export const VERSION_DETAILS_FALLBACK = "—";

/**
 * Rendered when the company's currency is still loading or unavailable. Deliberately empty
 * rather than a guessed symbol: a bare number is ambiguous, a wrong currency is misleading.
 */
export const DEFAULT_CURRENCY_CODE = "";

export const PRICE_DECIMAL_PLACES = 2;

// Kept in step with the backend DTO's @Min/@Max on the same fields.
export const MIN_NUMBER_OF_UNITS = 0;
export const MAX_NUMBER_OF_UNITS = 1_000_000_000_000;
export const MIN_PRICE_PER_UNIT = 0;
export const MAX_PRICE_PER_UNIT = 1_000_000_000;

export const VERSION_DETAILS_COPY = {
  sectionTitle: "Volume details",
  yearLabel: "Year",
  unitsLabel: "Number of units",
  priceLabel: "Price per unit",
  yearPlaceholder: "Year",
  unitsPlaceholder: "0",
  pricePlaceholder: "0.00",
  summaryYearLabel: "Year",
  summaryUnitsLabel: "Units",
  summaryPriceLabel: "Price",
  summarySeparator: "·",
  editAriaLabel: (versionLabel: string) => `Edit details for ${versionLabel}`,
  editTooltip: "Edit volume information",
  saveAriaLabel: (versionLabel: string) => `Save`,
  cancelAriaLabel: (versionLabel: string) => `Cancel`,
  deleteAriaLabel: (versionLabel: string) => `Delete`,
  unitsAriaLabel: (versionLabel: string) => `Number of units for ${versionLabel}`,
  priceAriaLabel: (versionLabel: string) => `Price per unit for ${versionLabel}`,
  saveSuccess: "Version details updated successfully",
  saveError: "Failed to update version details. Please try again.",
  deleteDialogTitle: "Delete version details",
  deleteConfirm: "Delete",
  deleteDialogBody: (versionLabel: string) =>
    `This removes the Year, Number of units, and Price per unit saved for ${versionLabel}. The calculation history itself is kept. This cannot be undone.`,
  deleteSuccess: "Version details deleted successfully",
  deleteError: "Failed to delete version details. Please try again.",
  unitsInvalid: "Enter a whole number of units (0 or more)",
  unitsTooLarge: "Number of units is too large",
  priceInvalid: `Enter a price of 0 or more with up to ${PRICE_DECIMAL_PLACES} decimals`,
  priceTooLarge: "Price per unit is too large"
} as const;
